export default "__VITE_ASSET__Ch4ZsE6b__"